import React from 'react';
import { numberLayer } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const NumberLayer = (props) => {
  const name = 'number_of_layers';

  const {
    label,
    options,
    parameters,
    onChangeParameter,
    required,
    tooltip,
    inputId,
    groupName,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      inputId={inputId}
      disabled={disabled} />
  );
};

NumberLayer.defaultProps = {
  inputId: 'number-of-layers',
  options: numberLayer,
  label: Spree.translations.parameters.number_of_layers,
  tooltip: Spree.helpForParameters.number_of_layers,
};

export default NumberLayer;
